import ExcelJS from "exceljs";
import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { QUESTIONS_URLS } from "../../api/AdminUrls";
import ImportForm from "../../components/ImportForm";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import {
  showAlertAutoClose,
  showYesOrNoAlert,
} from "../../services/notifyService";
import SdsImageLoader from "../../services/site/SdsImageLoader";
import { get, post } from "../../services/smartApiService";
import QuestionsForm from "./QuestionsForm";
import QuestionsViewDetails from "./QuestionsViewDetails";

import QuestionImageUploader from "./QuestionImageUploader";
import { LucideImageUp } from "lucide-react";
const Questions = () => {
  const [tabData, setTabData] = useState<any[]>([]);
  const [selected, setSelected] = useState<any[]>([]);
  const { openModal, closeModal, setTitle, user } = useSiteContext();
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN"]);
  const is_AGENCY = checkInterSection(user?.roles || [], ["AGENCY"]);
  const [currentPage, setCurrentPage] = useState(2); // ← maintain page state
  const pageSize = 30;

  const paginatedData = tabData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const loadTableData = () => {
    let URL = QUESTIONS_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
      //
      const sel = response.data
        .filter((item: any) => item.status === "active")
        .map((item: any) => item.id);
      //  const sel = response.data.map((item: any) => item.id);
      setSelected(sel);
      //console.log("tab data", sel);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
    setTitle("Questions");
  }, []);

  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Questions Form" : "Questions Form"}</>,
      content: <QuestionsForm loadTableData={loadTableData} dataIn={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

  const openOfferDetails = (data: any) => {
    let options = {
      title: "Question Details",
      content: <QuestionsViewDetails tableData={data} />,
      width: 60,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };
  const viewDetailsForm = (id: any) => {
    // console.log("id", id);
    const subscription = post(QUESTIONS_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openOfferDetails(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const deleteData = (id: any) => {
    const subscription = post(QUESTIONS_URLS.DELETE, { id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadTableData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Question Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Question? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };
  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => {
        viewDetailsForm(data["id"]);
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => {
        openDeleteModal(data["id"]);
      },
      hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
  ];

  const resultsTable = (data: any[]) => {
    const failedData = data.filter((item) => item.status === 10);

    const total = data.length;
    const failed = failedData.length;
    const success = total - failed;

    const cols: any = [
      { title: "S.NO", index: "s_no", type: "sno", width: "5" },
      {
        title: "Category",
        index: "category_name",
      },
      {
        title: "Questions Title",
        index: "question_english",
      },
      {
        title: "No. of Options",
        index: "correct_option_id",
      },
      {
        title: "Status",
        index: "status",
      },
      {
        title: "Message",
        index: "msg",
      },
    ];

    const tableTop_one: SmartTableNewInterface.SmartTableNewTopProps[] = [
      {
        type: "CUSTOM",
        widthClass: "is-12",
        custom: (
          <div className="is-flex is-justify-content-space-between is-align-items-center px-2 py-1">
            <span className="tag is-info is-light">Total: {total}</span>
            <span className="tag is-success is-light">Success: {success}</span>
            <span className="tag is-danger is-light">Failed: {failed}</span>
          </div>
        ),
      },
    ];

    return (
      <SmartTable
        columns={cols}
        tableTop={tableTop_one}
        data={failedData}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
        }}
        paginationProps={{ pageSize: 10 }}
      />
    );
  };

  const openImportModal = (data: any) => {
    const modalObject = {
      title: "Import Questions",
      content: (
        <ImportForm
          url={QUESTIONS_URLS.IMPORT_EXCEL}
          loadData={loadTableData}
          resultsTable={resultsTable}
        />
      ),
      className: "sd-efl-modal",
      width: 90,
    };
    openModal(modalObject);
  };

  const viewImageForm = (id: any) => {
    const subscription = post(QUESTIONS_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openImage_upload(response.data, id);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openImage_upload = (data: any, id: any) => {
    const options = {
      title: "Question Image",
      content: (
        <QuestionImageUploader
          loadTableData={loadTableData}
          id={id}
          dataIn={data}
        />
      ),
      width: 40,
      className: "sd-efl-modal",
      closeBody: false,
    };

    openModal(options);
  };

  const GetImage = (_data: any) => {
    return (
      <div
        className="has-text-centered smart-icon-pointer"
        onClick={() => viewImageForm(_data.id)}
      >
        {_data?.question_image ? (
          <SdsImageLoader
            name="logo"
            id={_data.id}
            url={QUESTIONS_URLS.GET_IMAGE}
            containerStyle={{ width: "50px", height: "50px", margin: "auto" }}
            imageStyle={{ borderRadius: "50%" }}
          />
        ) : (
          <div
            className="is-primary smart-icon-pointer"
            onClick={(e) => {
              viewImageForm(_data.id);
            }}
          >
            <LucideImageUp size={30} />
          </div>
        )}
      </div>
    );
  };
  // const StatusUpdate = (id: number, status: any) => {
  //   const subscription = post(QUESTIONS_URLS.STATUS_UPDATE, {
  //     id: id,
  //     status: status,
  //   }).subscribe((response) => {
  //      loadTableData();
  //   });
  //   return () => {
  //     subscription.unsubscribe();
  //   };
  // };

  const toggleId = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const StatusUpdate = (id: number, status: any) => {
    const subscription = post(QUESTIONS_URLS.STATUS_UPDATE, {
      id,
      status,
    }).subscribe((response) => {
      toggleId(id);
      // console.log("Updating row", id, "with", response?.data?.status ?? status);
      // setTabData((prevData) => {
      //   const updatedData = prevData.map((row) =>
      //     row.id == id
      //       ? { ...row, status: response?.data?.status ?? status }
      //       : row
      //   );
      //   return [...updatedData]; // force new array reference
      // });
    });

    return () => subscription.unsubscribe();
  };

  const updateStatus = (itemIn: any) => {
    let new_status: any = itemIn.status === "active" ? "inactive" : "active";
    let msg: any =
      new_status === "active"
        ? "Do you wish to Change Question is Active?"
        : "Do you wish to Change Question is Inactive?";
    showYesOrNoAlert(
      msg,
      (selection: Selection) =>
        updateStatusFinal(selection, itemIn, new_status),
      "info"
    );
  };

  const exportexl = async () => {
    const title = "Questions Export";
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(title);

    const headers = [
      "S.NO",
      "Category",
      "Question (English)",
      "Question (Hindi)",
      "Option-1 (E)",
      "Option-1 (H)",
      "Option-2 (E)",
      "Option-2 (H)",
      "Option-3 (E)",
      "Option-3 (H)",
      "Option-4 (E)",
      "Option-4 (H)",
      "Answer",
    ];

    worksheet.mergeCells(`A1:${worksheet.getColumn(headers.length).letter}1`);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Questions";
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };

    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(2);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9E1F2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    tabData.forEach((item: any, index: number) => {
      const options = item.sub_data || [];

      // Normalize options to ensure 4 are always present
      const normalizedOptions = Array(4)
        .fill(null)
        .map((_, i) => ({
          en: options[i]?.option_en || "",
          hi: options[i]?.option_hi || "",
        }));

      const row = [
        index + 1,
        item.category_name || "",
        item.ques_en || "",
        item.ques_hi || "",
        normalizedOptions[0].en,
        normalizedOptions[0].hi,
        normalizedOptions[1].en,
        normalizedOptions[1].hi,
        normalizedOptions[2].en,
        normalizedOptions[2].hi,
        normalizedOptions[3].en,
        normalizedOptions[3].hi,
        item.correct_option || "",
        // item.question_image ? `q${index + 1}.png` : "",
      ];

      const addedRow = worksheet.addRow(row);
      addedRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Set column widths
    headers.forEach((_, i) => {
      worksheet.getColumn(i + 1).width = 22;
    });

    // Download Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Questions Export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const exportexl_empty = async () => {
    const title = "Questions Export";
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(title);

    const headers = [
      "S.NO",
      "Category",
      "Question (English)",
      "Question (Hindi)",
      "Option-1 (E)",
      "Option-1 (H)",
      "Option-2 (E)",
      "Option-2 (H)",
      "Option-3 (E)",
      "Option-3 (H)",
      "Option-4 (E)",
      "Option-4 (H)",
      "Answer",
    ];

    worksheet.mergeCells(`A1:${worksheet.getColumn(headers.length).letter}1`);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Questions";
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };

    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(2);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9E1F2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    headers.forEach((_, i) => {
      worksheet.getColumn(i + 1).width = 22;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Questions Export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const updateStatusFinal = (selection: any, itemIn: any, new_status: any) => {
    if (selection === "yes") {
      itemIn.status = new_status;
      StatusUpdate(itemIn.id, new_status);
    }
  };

  const SwitchForm = (item: any) => {
    // console.log("SwitchForm item", selected);
    return (
      item.id && (
        <>
          <div className="field">
            <input
              id={`switchExample_${item.id}`}
              type="checkbox"
              name={`switchExample_${item.id}`}
              className="switch is-small"
              checked={selected.includes(item.id) ? true : false}
              onChange={() => updateStatus(item)}
              disabled={is_admin ? false : true}
            />
            <label htmlFor={`switchExample_${item.id}`}></label>
          </div>
        </>
      )
    );
  };

  const showStatusColumn = true; // or set based on some logic

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    {
      title: "Category",
      index: "category_name",
    },
    {
      title: "Questions",
      index: "ques_en",
    },
    {
      title: "No. of Options",
      index: "option_count",
    },
    {
      title: " Image",
      index: "ename",
      valueFunction: GetImage,
    },

    ...(is_admin
      ? [
          {
            title: "Status",
            index: "status",
            valueFunction: SwitchForm,
          },
        ]
      : []),
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4-tablet is-hidden-touch",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },

    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align: "CENTER",
      custom: (
        <div className="is-size-4">
          <span
            className="icon is-clickable excel-refresh-icon mx-3"
            onClick={loadTableData}
          >
            <i className="fa fa-refresh"></i>
          </span>

          <span
            className="icon ml-4 mx-3 is-clickable excel-export-icon"
            onClick={exportexl}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Export"
          >
            <i className="fa fa-upload"></i>
          </span>
          <span
            className="is-size-4 ml-3 excel-export-icon is-clickable mr-4"
            onClick={exportexl_empty}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Download"
          >
            <i className="fa fa-file"></i>
          </span>
        </div>
      ),
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        // {
        //   type: "REFRESH",
        //   action: loadTableData,
        // },
        // {
        //   type: "EXPORT",
        //   className: "smart-third-button",
        // },
        {
          label: "Import",
          icon: "fa-download",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openImportModal,
        },
        {
          label: "Add",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openOfficesForm,
        },
      ],
    },
  ];

  const tableTopNormal: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },

    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align: "CENTER",
      custom: (
        <div className="is-size-4">
          <span
            className="icon is-clickable excel-refresh-icon mx-3"
            onClick={loadTableData}
          >
            <i className="fa fa-refresh"></i>
          </span>

          <span
            className="icon ml-4 mx-3 is-clickable excel-export-icon"
            onClick={exportexl}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Export"
          >
            <i className="fa fa-upload"></i>
          </span>
          <span
            className="is-size-4 ml-3 excel-export-icon is-clickable mr-4"
            onClick={exportexl_empty}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Download"
          >
            <i className="fa fa-file"></i>
          </span>
        </div>
      ),
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        // {
        //   type: "REFRESH",
        //   action: loadTableData,
        // },
        // {
        //   type: "EXPORT",
        //   className: "smart-third-button",
        // },
        // {
        //   label: "Import",
        //   icon: "fa-download",
        //   type: "CUSTOM",
        //   className: "smart-third-button",
        //   action: openImportModal,
        // },
        // {
        //   label: "Add",
        //   icon: "fa-plus",
        //   type: "CUSTOM",
        //   className: "smart-third-button",
        //   action: openOfficesForm,
        // },
      ],
    },

    {
      type: "BUTTONS",
      widthClass: "is-3",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
      ],
    },
  ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          //  key={tabData.length}
          columns={columns}
          data={tabData}
          tableTop={is_admin ? tableTop : tableTopNormal}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          allowColumnSection={true}
          paginationProps={{ pageSize: 30 }}
          // exportFileName="Asset Report"
          // exportTitle="Asset Report"
        />
      </div>
    </>
  );
};

export default Questions;
